import { createSlice } from '@reduxjs/toolkit';

interface LoginModalState {
  isOpen: boolean;
}

const initialState: LoginModalState = {
  isOpen: false,
};

export const loginModalSlice = createSlice({
  name: 'loginModal',
  initialState,
  reducers: {
    openLoginModal(state) {
      state.isOpen = true;
    },
    closeLoginModal(state) {
      state.isOpen = false;
    },
    toggleLoginModal(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openLoginModal, closeLoginModal, toggleLoginModal } = loginModalSlice.actions;
export default loginModalSlice.reducer;
